// src/components/RequireAuth.jsx
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RequireAuth() {
  const { user } = useAuth();
  const location = useLocation();

  // ❌ No hay sesión → redirigir con contexto
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // ✔ sesión válida
  return <Outlet />;
}